import { Quote } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { siteContent } from '../config/siteContent';

const referenceKeys = [
  { key: 'r1', company: 'TechCorp Industries', person: 'Michael Schmidt' },
  { key: 'r2', company: 'HealthCare Plus', person: 'Dr. Sarah Weber' },
  { key: 'r3', company: 'LogiFlow GmbH', person: 'Thomas Müller' },
];

export default function References() {
  const { t } = useLanguage();

  if (!siteContent.showCaseStudies) return null;

  return (
    <section id="references" className="py-20 px-6 bg-soft dark:bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-dark dark:text-white mb-4">
            {t('references.title')}
          </h2>
          <p className="text-lg text-muted dark:text-gray-300 max-w-3xl mx-auto">
            {t('references.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {referenceKeys.map(({ key, company, person }) => (
            <div
              key={key}
              className="card-base p-8"
            >
              <Quote className="w-10 h-10 text-primary mb-5" />

              <div className="mb-5">
                <h3 className="text-xl font-bold text-primary dark:text-accent-light mb-2">{t(`references.${key}.result`)}</h3>
                <div className="text-sm font-semibold text-dark dark:text-white">{company}</div>
                <div className="text-sm text-muted dark:text-gray-400">{t(`references.${key}.industry`)}</div>
              </div>

              <p className="text-muted dark:text-gray-300 leading-relaxed mb-5 italic text-sm">
                "{t(`references.${key}.quote`)}"
              </p>

              <div className="pt-5 border-t border-line dark:border-gray-700">
                <div className="font-bold text-dark dark:text-white">{person}</div>
                <div className="text-sm text-primary dark:text-accent-light font-medium">{t(`references.${key}.position`)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
